import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_DE.json';
import exercises from './YOGA_EXERCISES_DE.json';
import recipes from './YOGA_RECIPES_DE.json';

export const YOGA_DATA_DE: ServiceData = {
  articles,
  exercises,
  recipes,
};
